import { Outlet, useMatches } from "react-router-dom";
import { useEffect, Suspense, type FC } from "react";
import { appSettings } from '@/config/index';
import { AuthProvider, LoadingBarProvider } from '@/app/providers';
import EnvironmentBadge from '@/shared/components/common/EnvironmentBadge';

interface RouteHandle {
  title?: string;
}

const RootLayout: FC = () => {
  const matches = useMatches();

  useEffect(() => {
    const currentMatch = matches[matches.length - 1];
    const handle = currentMatch?.handle as RouteHandle | undefined;
    const title = handle?.title;

    if (title) {
      document.title = `${title} - ${appSettings.app.name}`;
    } else {
      document.title = appSettings.app.name;
    }
  }, [matches]);

  return (
    <AuthProvider>
      <LoadingBarProvider>
        <div className="h-screen bg-gray-50 overflow-hidden">
          <Suspense fallback={
            <div className="flex items-center justify-center h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
          }>
            <Outlet />
          </Suspense>
          <EnvironmentBadge />
        </div>
      </LoadingBarProvider>
    </AuthProvider>
  );
};

export default RootLayout;
